import { createAction } from '@reduxjs/toolkit';
import createThunkPost from './utils/createThunkPost';

export const setDownloadedUser = createAction('setDownloadedUser');
export const setViewMode = createAction('setViewMode');

export const updateUsers = createThunkPost('updateUsers', {
  headers: { 'Content-Type': 'application/json' },
});
